import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getTechnologiesOokla } from '@api/ookla';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { ITechnologiesOoklaDTO } from '@interfaces/platform/dto/ooklaDTO';

import { refetchOptions } from '@constants/common';
import { TECHNOLOGIES_OOKLA } from '@constants/queryKeys';

interface IUseQueryAllTechnologiesOoklaReturn {
	isLoadingAllTechnologiesOokla: boolean;
	allTechnologiesOokla: Array<TSelectOption>;
}

export const useQueryAllTechnologiesOokla = (): IUseQueryAllTechnologiesOoklaReturn => {
	const {
		accessPermission: {
			assetConsumerOrganizationAdministrator,
			networkOperatorOrganizationAdministrator,
			assetOwnerOrganizationAdministrator,
		},
	} = useAppSelector(auth);

	const isAllowed = (
		assetConsumerOrganizationAdministrator ||
		networkOperatorOrganizationAdministrator ||
		assetOwnerOrganizationAdministrator
	);

	const {
		data: allTechnologiesOokla,
		isLoading: isLoadingAllTechnologiesOokla,
		isFetching: isFetchingAllTechnologiesOokla,
	} = useQuery({
			queryKey: [TECHNOLOGIES_OOKLA],
			queryFn: getTechnologiesOokla,
			select: (technology: ITechnologiesOoklaDTO[]) => {
				return technology?.map(item => {
					return {
						...item,
						value: item.id,
						name: item.name,
						label: item.name,
					};
				});
			},
			enabled: [isAllowed],
			...refetchOptions,
		},
	);

	return {
		isLoadingAllTechnologiesOokla: isLoadingAllTechnologiesOokla || isFetchingAllTechnologiesOokla,
		allTechnologiesOokla: allTechnologiesOokla || [],
	};
};
